// extracted by mini-css-extract-plugin
export default {"cls1":"PunA2IcNOanivid1eJtQ","cls2":"iXDh65dMsZNoNXbl7yGi PunA2IcNOanivid1eJtQ"};